// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import { manifestObjectToManifestRequest, manifestResponseToManifestObject } from '../../helpers/mappers/manifest';

import {
    getAllManifests as getAllManifestsApi,
    createManifest as createManifestApi,
    getManifest as getManifestApi
} from '../../helpers';

import { manifestsApiResponseSuccess, manifestsApiResponseError } from './actions';
import { ManifestsActionTypes } from './constants';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

const getManifestErrorMessage = (error, fallback = 'Unable to process manifest request') =>
    error?.errors?.[0]?.message || error?.message || fallback;

function* manifestsGetAllManifests({ payload: { query, returnImage } }) {
    try {
        const getAllManifestsResponse = yield call(getAllManifestsApi, query, returnImage);
        const manifests = getAllManifestsResponse.data.map(manifestResponse => manifestResponseToManifestObject(manifestResponse));
        const pagination = { ...paginationHeadersResponse(getAllManifestsResponse.headers), ...query };
        yield put(manifestsApiResponseSuccess(ManifestsActionTypes.GET_ALL_MANIFESTS, { manifests, pagination }));
    } catch (error) {
        yield put(addToast({ desc: getManifestErrorMessage(error, 'Unable to load manifests'), type: 'error' }));
        yield put(manifestsApiResponseError(ManifestsActionTypes.GET_ALL_MANIFESTS, error));
    }
}

function* manifestsCreateManifestForAllUnmanifested({ payload: { returnImage } }) {
    try {
        const createManifestResponse = yield call(createManifestApi, { 'carrier': 'usps' }, returnImage);
        yield put(manifestsApiResponseSuccess(ManifestsActionTypes.CREATE_MANIFEST_FOR_ALL_UNMANIFESTED, createManifestResponse.data));
    } catch (error) {
        yield put(addToast({ desc: getManifestErrorMessage(error, 'Unable to create manifest'), type: 'error' }));
        yield put(manifestsApiResponseError(ManifestsActionTypes.CREATE_MANIFEST_FOR_ALL_UNMANIFESTED, error));
    }
}

function* manifestsCreateManifest({ payload: { manifestSpec, returnImage } }) {
    try {
        const request = manifestObjectToManifestRequest(manifestSpec);
        const createManifestResponse = yield call(createManifestApi, request, returnImage);
        yield put(manifestsApiResponseSuccess(ManifestsActionTypes.CREATE_MANIFEST, createManifestResponse.data));
        yield put(addToast({ desc: 'Manifest created successfully', type: 'success' }));
    } catch (error) {
        yield put(addToast({ desc: getManifestErrorMessage(error, 'Unable to create manifest'), type: 'error' }));
        yield put(manifestsApiResponseError(ManifestsActionTypes.CREATE_MANIFEST, error));
    }
}

function* manifestsGetManifest({payload: { manifestId, returnImage }}) {
    try {
        const getManifestResponse = yield call(getManifestApi, manifestId, returnImage);
        const manifest = manifestResponseToManifestObject(getManifestResponse.data);
        yield put(manifestsApiResponseSuccess(ManifestsActionTypes.GET_MANIFEST, manifest));
    } catch (error) {
        yield put(addToast({ desc: getManifestErrorMessage(error, 'Unable to load manifest'), type: 'error' }));
        yield put(manifestsApiResponseError(ManifestsActionTypes.GET_MANIFEST, error));
    }
}

export function* watchManifestsGetAllManifests(): any {
    yield takeLatest(ManifestsActionTypes.GET_ALL_MANIFESTS, manifestsGetAllManifests);
}

export function* watchManifestsCreateManifestForAllUnmanifested(): any {
    yield takeLatest(ManifestsActionTypes.CREATE_MANIFEST_FOR_ALL_UNMANIFESTED, manifestsCreateManifestForAllUnmanifested);
}

export function* watchManifestsCreateManifest(): any {
    yield takeLatest(ManifestsActionTypes.CREATE_MANIFEST, manifestsCreateManifest);
}

export function* watchManifestsGetManifest(): any {
    yield takeLatest(ManifestsActionTypes.GET_MANIFEST, manifestsGetManifest);
}

function* manifestsSaga(): any {
    yield all([
        fork(watchManifestsGetAllManifests),
        fork(watchManifestsCreateManifest),
        fork(watchManifestsCreateManifestForAllUnmanifested),
        fork(watchManifestsGetManifest)
    ]);
}

export default manifestsSaga;
